import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import classNames from 'classnames';
import config from 'config';
import { SELL_ADD_PRODUCT } from 'config/fe-routes';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { UserType } from 'types/user.types';
import { GTM, GTMButtons, GTMLocations } from 'utils/analytics';
import { redirectTo } from 'utils/route-helpers';

import useGlobalContext from '../../hooks/useGlobalContext';

const buyerProtectionFeeEnabled = config.get('buyerProtectionFeeEnabled');

type Props = {
  user: UserType;
};

const mapStateToProps = ({ userData }) => ({
  user: userData && userData.user,
});

const SellButton = (props: Props) => {
  const { user } = props;
  const { t } = useTranslation();
  const { get: getFromContext } = useGlobalContext();
  const isDownloadAppBannerHidden = getFromContext('isDownloadAppBannerHidden') as boolean;

  const isLoggedIn = !!user?.isLoggedIn;

  return (
    <Button
      variant="contained"
      color="primary"
      size="large"
      onClick={() => {
        GTM.buttonClicked(GTMButtons.ADD_PRODUCT, GTMLocations.MAIN_BUTTON);

        redirectTo(SELL_ADD_PRODUCT(undefined, 'sell_fab'));
      }}
      startIcon={isLoggedIn ? <AddIcon className="add-product-btn-icon" /> : null}
      className={classNames('global-sell-btn', { high: !isDownloadAppBannerHidden })}
    >
      <span>
        {isLoggedIn ? t('common.add-product') : t(buyerProtectionFeeEnabled ? 'common.start-selling-for-free' : 'common.start-selling')}
      </span>
    </Button>
  );
};

export default connect(mapStateToProps)(SellButton);
